// extracted by extract-css-chunks-webpack-plugin
module.exports = {"course":"course_1Gzu2","title":"title_1m8F8","content":"content_24bb7","list":"list_3moFT"};